/* eslint-disable max-lines */
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isMobile } from 'react-device-detect';

import CookieStorageService from 'services/CookieStorageService';
import { getActiveLanguageCode, translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';
import Disclaimer from 'components/Disclaimer/Disclaimer';
import LanguageSelection from 'components/LanguageSelection/LanguageSelection';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';
import {
  GENDER_PREFERENCE_REGEX,
  PARSED_CHECKING_FOR_CRAWLERS,
} from 'enum/helpers';
import { GENDER } from 'enum/profile';
import routeDefinitions from 'enum/routeDefinitions';
import {
  SOCIAL_MEDIA,
  SOCIAL_MEDIA_BY_LANGUAGE,
  SOCIAL_MEDIA_ICONS as SM_ICONS,
  SOCIAL_MEDIA_LINKS as SM_LINKS,
  SOCIAL_MEDIA_SETTINGS as SM_SETTINGS,
} from 'enum/socialMediaLinks';
import allUserGroups from 'enum/userGroups';
import { generateID } from 'utils/helpers';
import { getGenderStr } from 'utils/gender';
import {
  isStudioAdminCheck,
  isStudioOwnerCheck,
} from 'utils/studio';
import {
  actionCreators as directoryListActions,
  selector as directorySelector,
} from 'pages/Directory/State';

import Hyperlink from '../Hyperlink/Hyperlink';
import icra from '../../../images/footer/icra.png';
import jusprog from '../../../images/footer/age-xml-icon_18.png';
import labeled from '../../../images/footer/labeled.gif';
import rta from '../../../images/footer/rta_b.png';

import styles from './Footer.css';


const json = require('../../../mock-data/footer-links.json');


const cam4Instagram = {
  name: 'CAM4 Instagram',
  bundleName: 'profile',
  key: 'profile.socialNetworks.cam4.instagram',
  url: 'https://www.instagram.com/menofcam4/',
};
const dmcaLink =
  `https://www.dmca.com/Protection/Status.aspx?ID=466fa1aa-ce2e-4b71-b329-6cd08d681302&refurl=${document.location}`;
const dmcaBadgeLink =
  'https://images.dmca.com/Badges/_dmca_premi_badge_4.png?ID=466fa1aa-ce2e-4b71-b329-6cd08d681302';
const icraLink = 'https://www.fosi.org/icra';
const jusprogLink = 'https://www.jugendschutzprogramm.de/download/';
const rtaLink = 'https://www.rtalabel.org/';
const safeLabelingLink = 'https://www.safelabeling.org/';

@connect(directorySelector, (dispatch) => {
  return { directoryActions: bindActionCreators(directoryListActions, dispatch) };
})
class Footer extends PureComponent {
  constructor(...args) {
    super(...args);

    this.IDS = {
      prefix: 'E055TFVV',
      element: 'footer',
      socialLink: (item) => `socialLink-${item}`,
      socialIcon: (item) => `socialIcon-${item}`,
      badge() {
        const element = 'badge';

        return {
          icra: `${element}-icra`,
          rtab: `${element}-rta_b`,
          labeled: `${element}-labeled`,
          jusprog: `${element}-jusprog`,
          dmca: `${element}-dmca`,
        };
      },
      siteMapLink: (item) => `siteMapLink-${item}`,
      legalSection() {
        const element = 'legalSection';

        return {
          terms: `${element}-Terms`,
          termsDmca: `${element}-TermsDmca`,
          privacy: `${element}-Privacy`,
          statement: `${element}-Statement`,
          impressum: `${element}-Impressum`,
          recordKeeping: `${element}-RecordKeeping`,
          knowYourClient: `${element}-KnowYourClient`,
          cookiesPolicy: `${element}-CookiesPolicy`,
          ccpa: `${element}-CCPA`,
          lawEnforcement: `${element}-law-inforcement`,
          webcamStudioAgreement: `${element}-WebcamStudioAgreement`,
          videoUploadRules: `${element}-VideoUploadRules`,
          contestGeneralRules: `${element}-ContestGeneralRules`,
          jsb: `${element}-jsb`,
          contentPolicy: `${element}-contentPolicy`,
        };
      },
    };
    this.makeId = generateID(this.IDS.prefix, this.IDS.element);

    this.blogKey = 'profile.new.cam4.blog';
    this.makeMoneyKey = 'footer.cam4bucks.make.money';
  }

  applyFilter = (loc, codes, url) => {
    const { directoryActions, initialFilters, history, genderPreference, path } = this.props;
    const popularCamsArray = Object.keys(routeDefinitions.popularCams).map((key) => routeDefinitions.popularCams[key]);

    if (
      popularCamsArray.includes(history.location.pathname) ||
      path === `/:genderPreference${GENDER_PREFERENCE_REGEX}/:filter*`
    ) {
      directoryActions.changeActiveFilterCollection(null);
      directoryActions
        .applyFilter(
          initialFilters
            .updateIn(['locale', loc], (list) =>
              list.map((val) => {
                if (codes.includes(val.get('code'))) {
                  return val.set('active', true);
                }

                return val.set('active', false);
              })
            )
            .updateIn(['shared', 'genders'], (genders) =>
              genders.map((gender) => {
                if (gender.get('value') === genderPreference) {
                  return gender.set('active', true);
                }

                return gender.set('active', false);

              })
            )
            .delete('showTag')
        )
        .then(history.push(url));
    } else {
      window.location = url;
    }
  };

  resolveGenderPreference = () => {
    const { path, genderPreference, user } = this.props;
    const userStoredGenderPreference = user.user.getIn(['user', 'genderPreference']);
    const { directory } = routeDefinitions;
    const dir = `/:genderPreference${GENDER_PREFERENCE_REGEX}/:filter*`;
    const layout = [directory, dir];
    const isDirectory = layout.includes(path);
    const isGuest = user && user.accessLevel < ACCESS_LEVEL_NUM.BASIC;
    const contentPreferenceCookie = CookieStorageService.get('cam4-CONTENT');
    const contentPreference = getGenderStr(contentPreferenceCookie, true);

    if (isDirectory && genderPreference) {
      return genderPreference;
    } else if (userStoredGenderPreference && userStoredGenderPreference !== GENDER.UNKNOWN) {
      return userStoredGenderPreference;
    } else if (contentPreference && isGuest) {
      return contentPreference;
    }

    return GENDER.FEMALE;
  };

  onApplyFilter = (option, filter, url) => () => {
    this.applyFilter(option, [filter], url);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  renderColumnContent = (column, isLangOrCountry, option) => {
    let content = undefined;
    if (isLangOrCountry) {
      content = this.renderLangAndCountryItems(option, column.links);
    } else {
      content = this.renderColumnItems(column.links);
    }

    return (
      <Fragment>
        <div className={styles.title}>
          {translate(column.title)}
        </div>
        {content}
      </Fragment>
    );
  };

  renderColumn = (column, isLangOrCountry, option) => (
    <div className={styles.column}>
      {this.renderColumnContent(column, isLangOrCountry, option)}
    </div>
  );

  renderColumns = (...columns) => (
    <div className={styles.column}>
      {columns.map((column) => this.renderColumnContent(column))}
    </div>
  );

  renderColumnItems = (columnItems) => {
    const genderPreference = this.resolveGenderPreference();
    if (columnItems[2] !== undefined && columnItems[2].name === 'Press Page') {
      if (genderPreference === GENDER.MALE && columnItems.length < 4) {
        columnItems.push(cam4Instagram);
      } else {
        columnItems.splice(3, 1);
      }
    }

    return columnItems.map((item) => {
      const activeLanguageCode = getActiveLanguageCode();

      if (item.key === this.blogKey) {
        if (item.urls[activeLanguageCode]) {
          item.url = item.urls[activeLanguageCode];
        } else {
          item.url = item.urls.en;
        }
      }

      if (item.key === this.makeMoneyKey) {
        if (item.urls[activeLanguageCode]) {
          item.url = item.urls[activeLanguageCode];
        } else {
          item.url = item.urls.en;
        }
      }

      const id = this.makeId(this.IDS.siteMapLink(item.name));

      return (
        <div key={id} className={styles.link} id={id}>
          <Hyperlink
            href={item.url}
            rel={`${item.isBlank ? 'noopener' : ''}`}
            target={`${item.isBlank ? '_blank' : '_self'}`}
          >
            {translate(`${item.bundleName}.${item.key}`)}
          </Hyperlink>
        </div>
      );
    });
  };

  renderLangAndCountryItems = (option, columnItems) => columnItems.map((item) => {
    let genderPreference = this.resolveGenderPreference();
    if (genderPreference === GENDER.SHEMALE) {
      genderPreference = GENDER.TRANSGENDER;
    }
    const url = item.url.replace('cams', genderPreference);
    const id = this.makeId(this.IDS.siteMapLink(item.name));

    return (
      <div key={id} className={styles.link} id={id}>
        <Hyperlink
          href={url}
          onClick={this.onApplyFilter(option, item.code, item.url)}
        >
          {translate(item.name)}
        </Hyperlink>
      </div>
    );
  });

  renderSocialIcons = (list = [...Object.values(SOCIAL_MEDIA)]) =>
    list.map((social) => {
      const activeLanguageCode = getActiveLanguageCode();
      const genderPreference = this.resolveGenderPreference();

      const uppercasedPreference = genderPreference.toUpperCase();
      let preference = uppercasedPreference;
      if (uppercasedPreference === SM_SETTINGS.GENDER_PREFERENCE.FEMALE) {
        preference = SM_SETTINGS.GENDER_PREFERENCE.DEFAULT;
      }

      const locale = activeLanguageCode.toUpperCase();
      const localeKey = `${SM_SETTINGS.LOCALE.LOCALE_SPECIFIC}${locale}`;
      const socialKey = `${social.toUpperCase()}`;
      const Icon = SM_ICONS[socialKey];

      let linksObj = SM_LINKS[SM_SETTINGS.LOCALE.LOCALE_DEFAULT][socialKey];
      if (SM_LINKS?.[localeKey]?.[socialKey]) {
        linksObj = SM_LINKS[localeKey][socialKey];
      }

      const chosenPreference = linksObj[preference];
      const defaultPreference = linksObj[SM_SETTINGS.GENDER_PREFERENCE.DEFAULT];
      let linkUrl = undefined;
      if (linksObj) {
        if (chosenPreference) {
          linkUrl = chosenPreference;
        } else if (defaultPreference !== '') {
          linkUrl = defaultPreference;
        } else {
          const defaultLocale = SM_SETTINGS.LOCALE.LOCALE_DEFAULT;
          const defaultGender = SM_SETTINGS.GENDER_PREFERENCE.DEFAULT;
          linkUrl = SM_LINKS[defaultLocale][socialKey][defaultGender];
        }
      }

      let isSocialMediaVisible = true;
      if (SOCIAL_MEDIA_BY_LANGUAGE[locale]) {
        isSocialMediaVisible = Object.values(SOCIAL_MEDIA_BY_LANGUAGE[locale]).includes(social);
      }

      return (linkUrl && isSocialMediaVisible) ? (
        <Hyperlink
          key={social}
          href={linkUrl}
          id={this.makeId(this.IDS.socialIcon(social))}
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          <Icon className={styles.socialMediaIcon} />
        </Hyperlink>
      ) : null;
    });

  renderStudioLinks = (list) => {
    const { user } = this.props;

    return list.map((link) => {
      const url = link.url.indexOf(':user') > -1 ? link.url.replace(':user', user.username) : link.url;
      if (isStudioAdminCheck(user) && link.name.toLowerCase() === 'settings') {
        return null;
      }
      const id = this.makeId(this.IDS.socialLink(link.name));

      return (
        <Hyperlink
          key={id}
          className={styles.studioLinks}
          href={url}
          id={id}
        >
          {translate(`${link.bundleName}.${link.key}`)}
        </Hyperlink>
      );
    });
  };

  render() {
    const activeLanguageCode = getActiveLanguageCode();
    const {
      isStudio,
      availableLanguages,
      userActions,
      dispatch,
      user,
      history,
      path,
    } = this.props;
    const mobileLoggedIn = isMobile && Boolean(user.username);
    const isUserLoggedIn = user.username !== null;
    const backgroundImageCF = UserStore.hasCF(allUserGroups.backgroundImageCF);
    const currentYear = new Date().getFullYear();
    const shouldShowStudioLinks =
      isStudioOwnerCheck(user) ||
      (isStudioAdminCheck(user) &&
        window.location.href.includes('performerhub'));
    const footerClass = classNames({
      [styles.footer]: true,
      [styles.isStudio]: isStudio,
    });

    return (
      <div
        className={footerClass}
        id={this.makeId()}
      >
        {!isStudioOwnerCheck(user) ? (
          <div className={`${styles.columnsNavigation} ${styles.centerFix}`}>
            <div className={styles.row}>
              {this.renderColumn(json.footer[0])}
              {this.renderColumn(json.footer[1])}
              {this.renderColumn(json.footer[2], true, 'countries')}
              {this.renderColumn(json.footer[3], true, 'languages')}
              {this.renderColumns(json.footer[4], json.footer[5])}
            </div>
          </div>
        ) : null}
        <div className={styles.socialContainer}>
          <div className={`${styles.centerFix} ${styles.alignCenter}`}>
            <div className={styles.social}>
              <div className={styles.socialWrapper}>
                {shouldShowStudioLinks ? this.renderStudioLinks(json['footer-studio']) : this.renderSocialIcons()}
              </div>
              <div className={styles.languageSelectorWrapper}>
                <LanguageSelection
                  availableLanguages={availableLanguages}
                  dispatch={dispatch}
                  prefixId={this.IDS.prefix}
                  userActions={userActions}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.legalContainer}>
          <div className={`${styles.legalSection} ${styles.hideOnMobile}`}>
            <div className={styles.row}>
              <span>
                <Hyperlink
                  href={routeDefinitions.termsofuse}
                  id={this.makeId(this.IDS.legalSection().terms)}
                >
                  {translate('cam4bucks.cam4bucks.95')}
                </Hyperlink>
              </span>
              <span className={styles.point}>●</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.privacy}
                  id={this.makeId(this.IDS.legalSection().privacy)}
                >
                  {translate('cam4bucks.cam4bucks.96')}
                </Hyperlink>
              </span>
              <span className={styles.point}>●</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.statementOfRights}
                  id={this.makeId(this.IDS.legalSection().statement)}
                >
                  {translate('menuoptions.menu.link.statement.of.rights')}
                </Hyperlink>
              </span>
              <span className={styles.point}>●</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.ccpa}
                  id={this.makeId(this.IDS.legalSection().ccpa)}
                >
                  {translate('menuoptions.menu.link.ccpa')}
                </Hyperlink>
              </span>
              <span className={styles.point}>●</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.lawEnforcement}
                  id={this.makeId(this.IDS.legalSection().lawEnforcement)}
                >
                  {translate('statementofrights.law.enforcement')}
                </Hyperlink>
              </span>
              <span className={styles.point}>●</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.legalContact}
                  id={this.makeId(this.IDS.legalSection().impressum)}
                >
                  {translate('contacts.contacts.legal.title')}
                </Hyperlink>
              </span>
              <span className={styles.point}>&#9679;</span>
              <span>
                <Hyperlink
                  href={routeDefinitions.contentPolicy}
                  id={this.makeId(this.IDS.legalSection().contentPolicy)}
                >
                  {translate('termsandconditions.content.policy.title')}
                </Hyperlink>
              </span>
            </div>
            {user.realCountry === 'de' && (
              <div className={styles.row}>
                <span className={styles.point}>●</span>
                <span>
                  <Hyperlink
                    href={routeDefinitions.jsb}
                    id={this.makeId(this.IDS.legalSection().jsb)}
                  >
                    {'Jugendschutzbeauftragter'}
                  </Hyperlink>
                </span>
              </div>
            )}
            <div className={styles.row}>
              <Hyperlink
                href={routeDefinitions.complianceStatement}
                id={this.makeId(this.IDS.legalSection().recordKeeping)}
              >
                {translate('recordkeeping.recordkeeping.title')}
              </Hyperlink>
              <span className={styles.point}>●</span>
              <Hyperlink
                href={routeDefinitions.knowYourClient}
                id={this.makeId(this.IDS.legalSection().knowYourClient)}
              >
                {translate('recordkeeping.knowyourclient.link')}
              </Hyperlink>
            </div>
            <div className={styles.row}>
              <Hyperlink
                href={routeDefinitions.termsofuseDmca}
                id={this.makeId(this.IDS.legalSection().termsDmca)}
              >
                {translate('cam4bucksterms.cam4bucksterms.point.11')}
              </Hyperlink>
            </div>
            <div className={styles.row} >
              <Hyperlink
                href={routeDefinitions.cookies}
                id={this.makeId(this.IDS.legalSection().cookiesPolicy)}
              >
                {translate('privacypolicy.privacy.cookies.main_title')}
              </Hyperlink>
            </div>
          </div>
          <span className={styles.row}>
            {translate('disclaimer.disclaimer.footer')}
          </span>
          <span className={styles.row}>
            {translate('privacypolicy.privacy.footer.address')}
          </span>
          <div className={styles.legalSection}>
            <span>
              {translate('menuoptions.all.rights.reserved.update', { 0: currentYear })}
            </span>
          </div>
          <div className={styles.hideOnMobile}>
            <Hyperlink
              href={icraLink} id={this.makeId(this.IDS.badge().icra)}
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              <img alt="icra" className={styles.badge} src={icra} />
            </Hyperlink>
            <Hyperlink
              href={rtaLink}
              id={this.makeId(this.IDS.badge().rtab)}
              rel="nofollow noopener noreferrer" target="_blank"
            >
              <img alt="rta_b" className={styles.badge} src={rta} />
            </Hyperlink>
            <Hyperlink
              href={safeLabelingLink}
              id={this.makeId(this.IDS.badge().labeled)}
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              <img alt="labeled" className={styles.badge} src={labeled} />
            </Hyperlink>
            {activeLanguageCode === 'de' && (
              <Hyperlink
                href={jusprogLink}
                id={this.makeId(this.IDS.badge().jusprog)}
                rel="nofollow noopener noreferrer"
                target="_blank"
              >
                <img alt="jusprog" className={styles.badge} src={jusprog} />
              </Hyperlink>
            )}
            <Hyperlink
              className={styles.badge}
              href={dmcaLink}
              id={this.makeId(this.IDS.badge().dmca)}
              rel="nofollow noopener noreferrer"
              target="_blank"
              title="DMCA.com Protection Status"
            >
              <img alt="DMCA.com Protection Status" src={dmcaBadgeLink} />
            </Hyperlink>
          </div>
        </div>
        {!PARSED_CHECKING_FOR_CRAWLERS &&
          path !== routeDefinitions.legal &&
          !mobileLoggedIn &&
          !isUserLoggedIn &&
          !backgroundImageCF && (
          <Disclaimer
            history={history}
            user={user}
            userActions={userActions}
          />
        )}
      </div>
    );
  }
}

Footer.propTypes = {
  availableLanguages: PropTypes.array,
  directoryActions: PropTypes.object,
  dispatch: PropTypes.func,
  genderPreference: PropTypes.string,
  history: PropTypes.object,
  initialFilters: PropTypes.object,
  isStudio: PropTypes.bool,
  path: PropTypes.string,
  user: PropTypes.object,
  userActions: PropTypes.object,
};

Footer.defaultProps = {
  availableLanguages: undefined,
  directoryActions: undefined,
  dispatch: undefined,
  genderPreference: undefined,
  history: undefined,
  initialFilters: undefined,
  isStudio: false,
  path: undefined,
  user: undefined,
  userActions: undefined,
};

export default Footer;
